<template>
  <div class="margin-top-half">
    <div
      class="content-devx"
    >
      <DxDataGrid
        id="ProductsDatabase-Datagrid"
        :data-source="products"
        :column-min-width="70"
        :column-auto-width="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        @RowRemoved="callToDeleteProduct"
        @exporting="onExporting"
        @toolbar-preparing="onToolbarPreparing($event)"
      >
        <DxSelection
          mode="single"
        />
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="ProductsDatabase"
        />
        <DxHeaderFilter :visible="true" />
        <DxExport
          :enabled="false"
        />
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="pageSizes"
          :show-info="true"
        />
        <DxSearchPanel
          :visible="true"
          :width="200"
          :placeholder="$t('Search_placeholder')"
        />
        <DxEditing
          :allow-deleting="true"
          :allow-updating="true"
          :confirm-delete="true"
        >
          <DxTexts
            :confirm-delete-message="$t('Confirm_Delete_Text')"
            :confirm-delete-title="$t('Confirm_Delete_Title')"
          />
        </DxEditing>
        <DxColumn
          data-field="name"
          width="30%"
          :caption="$t('DxProduct_nameCommercial')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="NT"
          :caption="$t('DxProduct_Ntotal')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="P2015_Total"
          :caption="$t('DxProduct_P205')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="K2O"
          :caption="$t('DxProduct_K20')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="CaO"
          :caption="$t('DxProduct_CaO')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          type="buttons"
          :fixed="true"
          fixed-position="right"
        >
          <DxButton
            name="find"
            icon="find"
            :on-click="showDetail"
          />
          <DxButton
            name="edit"
            icon="edit"
            :on-click="editProduct"
          />
          <DxButton
            name="delete"
            icon="trash"
          />
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxHeaderFilter,
  DxStateStoring,
  DxPager,
  DxSelection,
  DxEditing,
  DxButton,
  DxTexts,
} from 'devextreme-vue/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';

export default {
  name: 'ProductsDatabase',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxHeaderFilter,
    DxStateStoring,
    DxPager,
    DxSelection,
    DxEditing,
    DxButton,
    DxTexts,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pageSizes: [5, 10, 20],
    };
  },
  methods: {
    showDetail(rowSelected) {
      if (rowSelected.row.data.id) {
        this.initStore();
        this.updateCurrentProductProperty({ property: 'id', newValue: rowSelected.row.data.id });
        this.$f7.views.main.router.navigate('/viewProductDetail/', { reloadCurrent: true });
      }
    },
    editProduct(rowSelected) {
      if (rowSelected.row.data.id) {
        this.initStore();
        this.updateCurrentProductProperty({ property: 'id', newValue: rowSelected.row.data.id });
        this.$f7.views.main.router.navigate('/editProduct/', { reloadCurrent: true });
      }
    },
    async callToDeleteProduct(rowSelected) {
      this.$f7.preloader.show();
      try {
        await this.deleteProduct(rowSelected.data.id);
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          elementAttr: {
            class: 'add-task',
          },
          onClick: () => {
            this.initStore();
            this.$f7.views.main.router.navigate('/createProduct/', { reloadCurrent: true });
          },
        },
      });
    },
    onExporting(e) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('ProductsDatabase');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer()
          .then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ProductsDatabase.xlsx');
          });
      });
      e.cancel = true;
    },
    ...mapActions('Product', ['initStore', 'updateCurrentProductProperty', 'deleteProduct']),
  },
};
</script>
<style lang="scss" scoped>
@import './ProductsDatabase.styles.scss';
</style>
